import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import BasicLayout from '@/layouts/basic-layout';
var meta = {
  auth: ['admin']
};
export default {
  path: '/system',
  name: 'system',
  redirect: {
    name: "system-menu"
  },
  meta: meta,
  component: BasicLayout,
  children: [{
    path: '/system/menu',
    name: "system-menu",
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '菜单管理',
      icon: 'md-menu',
      cache: true
    }),
    component: function component() {
      return import('@/sys-pages/system/menu');
    }
  }, {
    path: '/system/user',
    name: "system-user",
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '用户管理',
      icon: 'ios-person',
      cache: true
    }),
    component: function component() {
      return import('@/sys-pages/system/user');
    }
  }, {
    path: '/system/role',
    name: "system-role",
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '角色管理',
      icon: 'ios-people',
      cache: true
    }),
    component: function component() {
      return import('@/sys-pages/system/role');
    }
  }, {
    path: '/system/dict',
    name: "system-dict",
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '数据字典',
      icon: 'ios-options',
      cache: true
    }),
    component: function component() {
      return import('@/sys-pages/system/dict');
    }
  }, {
    path: '/system/config',
    name: "system-config",
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '配置管理',
      icon: 'ios-settings',
      cache: true
    }),
    component: function component() {
      return import('@/sys-pages/system/config');
    }
  }, {
    path: '/system/tenant',
    name: "system-tenant",
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '租户管理',
      icon: 'md-walk',
      cache: true
    }),
    component: function component() {
      return import('@/sys-pages/system/tenant');
    }
  }]
};